import axios from 'axios';

import { ErrorResponse } from 'api';

/**
 * Extracts a user-friendly error message from a given error object.
 *
 * - If the error is an AxiosError and has a `response.data.message`, that message is returned.
 * - If the error is an AxiosError without a response message, it falls back to `error.message`.
 * - If it's a regular JavaScript `Error`, it uses `error.message`.
 * - For all other unknown types, it returns a customizable fallback message.
 *
 * @param error - The error object to extract a message from.
 * @param fallbackMessage - Optional fallback message if no specific message can be extracted.
 *                          Defaults to "An unexpected error has occurred".
 * @returns A string representing the error message.
 */
export function getApiErrorMessage(error: unknown, fallbackMessage = 'An unexpected error has occurred'): string {
  if (axios.isAxiosError<ErrorResponse>(error)) {
    if (typeof error.response?.data?.error?.message === 'string') {
      return error.response?.data?.error?.message;
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
}
